import { ReactComponent as AudiusColorLight } from 'fym-shared/src/music-services/assets/images/audius-color-light.svg';
import { ReactComponent as AudiusColorDark } from 'fym-shared/src/music-services/assets/images/audius-color-dark.svg';
import { ReactComponent as AudiusColorLightPadding } from 'fym-shared/src/music-services/assets/images/audius-color-light-padding.svg';
import { ReactComponent as AudiusColorDarkPadding } from 'fym-shared/src/music-services/assets/images/audius-color-dark-padding.svg';
import { MusicServiceImages } from './types';

export const audiusImages: MusicServiceImages = {
  logoColor: {
    light: AudiusColorLight,
    dark: AudiusColorDark,
  },
  logoColorPadding: {
    light: AudiusColorLightPadding,
    dark: AudiusColorDarkPadding,
  },
};
